import React from 'react';
import PropTypes from 'prop-types';

import DataForm from 'forms/DataForm';
import { resetFormCache } from 'forms/formCache';
import { request } from 'utilities/graph';
import { updateDeliveryStaff, adminCreateDeliveryStaff } from 'graphql/mutations';
import schema from './schema';
import uiSchema from './uiSchema';
import { deliveryStaffStatus } from '@silvergatedelivery/constants';
import { toastr } from 'react-redux-toastr';

import {
  getClientIdSchema,
} from 'forms/schemas';
import { useCache } from 'CacheProvider';

Object.assign(schema.properties.isActive, {
  type: 'number',
  enum: deliveryStaffStatus.map(({ value }) => value),
  enumNames: deliveryStaffStatus.map(({ label }) => label),
  default: 1,
});

export default function DeliverStaffForm(props) {
  const { formData } = props;
  const { appGroup } = useCache();

  const createFunc = async (data) => {
    data.county = data.county || data.address.county;
    data.phoneNumberCleaned = data.phoneNumber.replace(/\D/g, '') || 'N/A';
    const {
      isActive, county, clientId, username,
      licensePlate, tier, name, identificationCardId, birthday,
      gender, phoneNumber, email, jobOccupation, howDoYouKnowUs,
      experience, selfInfroduction, emergencyContact, bankAccount, address,
    } = data;
    const input = {
      isActive,
      county,
      clientId,
      username,
      password: identificationCardId, // 預設用身分證當密碼
      licensePlate,
      tier,
      name,
      identificationCardId,
      birthday,
      gender,
      phoneNumber,
      email,
      jobOccupation,
      howDoYouKnowUs,
      experience,
      selfInfroduction,
      emergencyContactName: emergencyContact.name,
      emergencyContactRelationship: emergencyContact.relationship,
      emergencyContactPhoneNumber: emergencyContact.phoneNumber,
      bankAccountName: bankAccount.name,
      bankAccountNumber: bankAccount.number,
      addressCounty: address.county,
      addressZipCode: address.zipCode,
      addressDistrict: address.district,
      addressStreet: address.street,
    };
    try {
      const { data: { adminCreateDeliveryStaff: { message, errors } } } = await request(adminCreateDeliveryStaff, { input });
      if (message === 'success') {
        resetFormCache('allDeliveryStaffs');
      } else {
        throw new Error(errors?.join(', ') || '');
      }
      resetFormCache('allDeliveryStaffs');
      window.alert('提醒：第一次登入請使用身分證字號作為密碼，登入後會需要修改密碼。');
    } catch (err) {
      console.log(err);
      toastr.error('建立送餐大使失敗', err.message);
      throw new Error(err);
    }
  };

  const updateFunc = async (data) => {
    data.county = data.county || data.address.county;
    data.phoneNumberCleaned = data.phoneNumber.replace(/\D/g, '') || 'N/A';
    await request(updateDeliveryStaff, { input: data });
    resetFormCache('allDeliveryStaffs');
  };

  uiSchema.username['ui:disabled'] = formData?.id ? true : false;
  uiSchema.email['ui:disabled'] = formData?.id ? true : false;

  return (
    <DataForm
      schema={schema}
      uiSchema={uiSchema}
      createFunc={createFunc}
      updateFunc={updateFunc}
      extMappings={[{
        key: 'clientId',
        func: (clientId) => {
          const adminMode = appGroup === 'Admins';
          return getClientIdSchema(clientId, '所屬機構', false, adminMode, false);
        },
      }]}
      {...props}
    />
  );
}

DeliverStaffForm.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  onComplete: PropTypes.func,
};
